var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isDesktop)?_c('ComparisonDesktop',{attrs:{"animation-enabled":_vm.animationEnabled}}):_c('ComparisonMobile')}
var staticRenderFns = []

export { render, staticRenderFns }